export default __webpack_public_path__ + "static/media/arbitrum.22df9eb1.svg";